



























































































import Vue from 'vue'
import moment from 'moment'
import request from '@/utils/request'
import pdfView from '@/views/content_manage/pdf_view.vue'
import { Toast } from 'vant'
import sha1 from 'sha1'
import { WECHAT_APPID, WECAHT_NAME, IMG_URL } from '@/utils/constants'
import { wxShare } from '@/utils/wxApi'
export default Vue.extend({
  data() {
    return {
      id: '' as any,
      data: {},
      font_type: 'middle',
    }
  },
  computed: {
    getFontSize() {
      switch (this.font_type) {
        case 'big':
          return '20px';
        case 'middle':
          return '18px';
        case 'small':
        default:
          return '16px';
      }
    }
  },
  async mounted() {
    this.id = 2
    await this.getData()

  },
  methods: {
    getData() {

      const params = {
        categoryId: this.id,
        limit: 1
      }
      request.get('/api/column/rest_article/show_list', params).then((data) => {
        if (data.length > 0) {
          const articleId = data[0].id
          request.get(`/api/column/rest_article/${articleId}`).then((data) => {
            if (data.enclosure) {
              const arr1 = data.enclosure.split('/')
              const str1 = arr1[arr1.length - 1]
              const arr2 = str1.split('.')
              data.enclosureStr = arr2[0]
              data.enclosureType = data.enclosure.split('.')[1]
            }
            this.data = data

          })
          this.data = data[0]
          this.initWeixin()
        }
        const alldata = JSON.parse(JSON.stringify(data))



      })
    },
    view(value: any) {
      const type = value.split('.')[1]
      if (type === 'png' || type === 'jpg' || type === 'jpeg' || type === 'mp4' || type === 'pdf') {
        let baseUrl = ''
        if (process.env.NODE_ENV == 'development') {
          baseUrl = 'https://tzwx.sxktqx.com'
        }
        window.location.href = `${baseUrl}/columnfiles${value}`
      } else {
        Toast.fail('暂不支持该格式')
      }
    },
    changeFontSize(type: string) {
      this.font_type = type
    },
    async initWeixin() {
      let title = '天气预报'
      //@ts-ignore
      title = this.data.title

      const url = window.location.href
      const timestamp = moment().valueOf()
      const nonceStr = 'tongzhouwechat'
      const jsapiTicket = await request.get('/api/account/office_account/jsapi_ticket')
      console.log('jsapiTicket', jsapiTicket)
      const params = `jsapi_ticket=${jsapiTicket}&noncestr=${nonceStr}&timestamp=${timestamp}&url=${url}`
      console.log('params', params)
      const signature = sha1(params)
      const obj = {
        appId: WECHAT_APPID,
        nonceStr: nonceStr,
        signature: signature,
        timestamp: timestamp,
      }

      let shareData = {
        title: WECAHT_NAME,
        desc: title,
        imgUrl: IMG_URL,
        link: url,
      };
      wxShare(obj, shareData);
    },
  },
  filters: {
    dtFormat(timestamp: number) {
      const time = moment(timestamp)
      return time.format('YYYY-MM-DD')
    },
  },
})
